angular.module('app').service('PhotoUtils', function($http, $mdDialog, $mdToast, $q, appUtils) {
    return {
        'refresh': function(photo) {
            photo.created_at = new Date();
        },
        'changeWidth': function(preview_url, new_width) {
            return preview_url.replace(/width=[0-9]*/, 'width=' + new_width);
        },
        'uploadImage': function(token_url, callback, data, accepts) {
            var PhotoUtils = this;

            if(!data) {
                data = {};
            }

            PhotoUtils.uploadDialog(
                function(file, onSuccess, onError) {
                    PhotoUtils.loadFileReaderImage(file, function(image) {
                        data.width = image.width;
                        data.height = image.height;
                        PhotoUtils.tokenUpload(
                            token_url,
                            function(response) {
                                onSuccess();
                                callback(response);
                            },
                            file,
                            data,
                            onError
                        );
                    });
                },
                "",
                accepts
            );
        },
        'replaceLineItemPhoto': function(li, type, preview_width) {
            var PhotoUtils = this;

            if(!type) {
                type = li.type;
            }

            if(!preview_width) {
                width = 100;
            }

            PhotoUtils.uploadDialog(
                function(file, onSuccess, onError) {
                    PhotoUtils.loadFileReaderImage(file, function(image) {
                        var data = {
                            'width': image.width,
                            'height': image.height,
                            'type': type,
                            'preview_width': preview_width,
                        };
                        PhotoUtils.tokenUpload(
                            '/api/v1/admin/line_item/' + li.id + '/replace_photo', 
                            function(response) {
                                li.photo.preview_url = response.data.preview_url
                                onSuccess();
                            },
                            file,
                            data,
                            onError
                        );
                    });
                },
                "Uploading an image on this screen will only replace the photo on the item you selected."
            );
        },
        'loadFileReaderImage': function(file, callback) {
            var PhotoUtils = this;

            var fr = new FileReader();
            fr.onload = function(e) {
                var data = new Uint8Array(fr.result);
                var image = new Image();
                image.onload = function() {
                    callback(image);
                };
                image.src = 'data:image/jpeg;base64,' + PhotoUtils.encode(data);
            }
            fr.readAsArrayBuffer(file);
        },
        'replace': function(photo, message, replace_url, accepts) {
            var PhotoUtils = this;
            if(!replace_url) {
                replace_url = '/api/v1/admin/photo/' + photo.id + '/replace'
            }

            PhotoUtils.uploadDialog(
                function(file, onSuccess, onError) {
                    PhotoUtils.loadFileReaderImage(file, function(image) {
                        var data = {
                            'width': image.width,
                            'height': image.height,
                        };
                        PhotoUtils.tokenUpload(
                            replace_url,
                            function(response) {
                                photo.id = response.data.id
                                photo.preview_url = response.data.preview_url
                                onSuccess();
                            },
                            file,
                            data,
                            onError
                        );
                    });
                },
                message,
                accepts
            );
        },
        'encode': function(input) { 
            var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            var output = "";
            var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            var i = 0;

            while (i < input.length) {
                chr1 = input[i++];
                chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index 
                chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output += keyStr.charAt(enc1) + keyStr.charAt(enc2) +
                        keyStr.charAt(enc3) + keyStr.charAt(enc4);
            }
            return output;
        },
        'uploadDialog': function(callback, extra_text, accepts) {
            $mdDialog.show({
                'controller': function() {
                    var main = this;
                    main.extra_text = extra_text;
                    main.accepts = accepts;

                    var onSuccess = function() {
                        $mdDialog.hide();
                    };

                    var onError = function() {
                        main.uploading = false;
                    };

                    main.uploadFile = function(file) {
                        if(!file) {
                            return;
                        }
                        main.uploading = true;
                        callback(file, onSuccess, onError)
                    };
                },
                'controllerAs': 'main',
                'clickOutsideToClose': true,
                'templateUrl': '/static/admin/templates/photo-upload.html?v=3',
                'multiple': true
            });
        },
        'upload': function(token_url, callback, data) {
            var photoUtils = this;

            if(data == null) {
                data = {};
            }

            photoUtils.uploadDialog(function(file, onSuccess, onError) {
                var upSuccess = function() {
                    callback();
                    onSuccess();
                }

                photoUtils.tokenUpload(
                    token_url,
                    upSuccess,
                    file,
                    data,
                    onError
                )
            });
        },
        'tokenUpload': function(token_url, callback, file, data, err) {
            data.size = file.size;
            data.filename = file.name;

            if(typeof err != 'function') {
                err = function() {};
            }
            $http({
                'method': 'POST',
                'url':  token_url,
                'data': data
            }).then(
                function(response) {
                    appUtils.fileReaderUpload(
                        response.data.upload_url, 'image/jpeg', file
                    ).then(
                        function(uploadResponse) {
                            callback(response);
                        },
                        err
                    );
                },
                err
            );
        },
    }
});
